
export const VUE_APP_SITE_ENTRANCE = '3dlivewall2022'